import { Component, OnInit } from '@angular/core';
import { Code } from './../../code/inputgroup';

@Component({
  templateUrl: './inputGroup.component.html'
})
export class InputGroupComponent implements OnInit {

  	code = Code;
  	val1: string = "val1";
    val2: string = 'val2';
    selectedValue : string = "val1";
	parameters: any[];
	eventHeader: any[];
	eventValue: any[];
	styleHeader: any[];
	styleValue: any[];
	items: any[]; 
	headers: any[];
  	constructor() { }

	  ngOnInit() {
	  	this.items = [
	        {label: 'Update', icon: 'fa ion-refresh', command: () => {
	            console.log(1)
	        }},
	        {label: 'Delete', icon: 'fa ion-close', command: () => {
	            console.log(2)
	        }},
	        {label: 'Angular.io', icon: 'fa-link', url: 'http://angular.io'},
	        {label: 'Theming', icon: 'fa-paint-brush', routerLink: ['/theming']}
	    ];
	  	this.parameters = [
	  		{name: "name",type: "string",default: "null",des: "单选按钮组的名字"},
	  		{name: "value",type: "any",default: "null",des: "单选按钮的值"},
	        {name: "label",type: "string",default: "null",des: "单选按钮的标签"},
	        {name: "disabled",type: "boolean",default: "false ",des: "改属性被指定，被指定元素不可用。"},
	        {name: "inputId",type: "string",default: "null ",des: "为组件在聚焦的输入框匹配标签"},
	        {name: "dir",type: "string",default: "null ",des: "指示元素的方向"},
	        {name: "style",type: "string",default: "null",des: "组件行内样式"},
	        {name: "styleClass",type: "string",default: "null",des: "组件class样式"},
	        {name: "labelStyleClass",type: "string",default: "null",des: "标签的class样式。"}
	    ];
	    
	    this.headers = [
	        {name : "名字"},
	        {name : "类型"},
	        {name : "默认"},
	        {name : "描述"}
	    ];

	    this.eventHeader = [
	    	{name : "名字"},
	        {name : "参数"},
	        {name : "描述"}
	    ];

	    this.eventValue = [
	    	{name : "onClick",param : "-",event :"当按钮被点击时回调onClick事件" }
	    ];

	    this.styleHeader = [
	    	{name : "名字"},
	        {name : "元素"}
	    ];

	    this.styleValue = [
	    	{name : "ui-radiobutton",el : "容器元素"},
	    	{name : "ui-radiobutton-box",el : "容器图标"},
	    	{name : "ui-radiobutton-iconu",el : "图标元素"},
	    	{name : "ui-chkbox-label",el : "标签元素"},
	    	{name : "ui-label-active",el : "标签元素被选中的状态"},
	    	{name : "ui-label-focus",el : "标签元素聚焦的状态"},
	    	{name : "ui-label-disabled",el : "标签元素禁用的状态"},
	    ];
	  }

}



// WEBPACK FOOTER //
// ./src/app/view/inputGroup/inputGroup.component.ts